import { FC } from 'react';
import { Modal } from 'components/Base/Modal';
import Spinner from 'components/Base/Spinner';
import { SMergeProgress } from '../../DuplicateMerge.styles';

type TRestoreConfirmModalProps = {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const RestoreConfirmModal: FC<TRestoreConfirmModalProps> = ({
  open,
  loading,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      title="Restore merge"
      open={open}
      onCancel={loading ? undefined : onCancel}
      onOk={onConfirm}
      okText="Restore"
      cancelText="Cancel"
      okButtonProps={{ loading }}
      cancelButtonProps={{ disabled: loading }}
      closable={!loading}
      maskClosable={!loading}
    >
      <p>
        This will reverse the merge. The previously-deleted record will be
        restored and all field changes rolled back.
      </p>
      {loading && (
        <SMergeProgress>
          <Spinner spinnerSize={20} /> <span>Restoring…</span>
        </SMergeProgress>
      )}
    </Modal>
  );
};

export default RestoreConfirmModal;
